<template>
  <section class="app-section">
    <header class="app-header">
      <h2 class="app-h2">ホーム</h2>
    </header>
    <div class="p2">
      <section class="section p2">
        <header class="section-header my4 py1">
          <h2 class="section-h2 m0 pl1">{{ appName }}の使い方</h2>
        </header>
        <div class="section-content px2">
          <instruction class="GitHubMarkdown"></instruction>
        </div>
      </section>
      <section class="section p2">
        <header class="section-header my4 py1">
          <h2 class="section-h2 m0 pl1">メニューの説明</h2>
        </header>
        <div class="section-content px2">
          <sidemenus class="GitHubMarkdown"></sidemenus>
        </div>
      </section>
      <section class="section p2">
        <header class="section-header my4 py1">
          <h2 class="section-h2 m0 pl1">アップデート情報</h2>
        </header>
        <div class="section-content px2">
          <updates class="GitHubMarkdown updates"></updates>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import updates from './home-updates.md'
import instruction from './home-instruction.md'
import sidemenus from './home-sidemenus.md'

export default {
  name: 'index',
  components: {
    updates,
    instruction,
    sidemenus
  },
  computed: {
    appName: {
      get () { return this.$store.getters['app/name'] }
    }
  }
}
</script>

<style lang="scss">
.GitHubMarkdown.updates {
  td:first-child {
    width: 140px;
  }
}
</style>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';
.section {
  &-header {
    border-left: 5px solid $--color-primary;
  }
  &-h2 {
    font-size: 1.4em;
    line-height: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/routes/Home.vue